import { RepositoryProjectBranch } from "../../utils";

export class PackageRepository extends RepositoryProjectBranch {
  apiUrl = '/api/v1/packages/';
}
